const FloatingWhatsApp = ({ 
  phoneNumber = '918123038270', 
  defaultMessage = 'Hello CAWT Team, I would like to get in touch regarding animal rescue / support.'
}) => {
  const encodedMessage = encodeURIComponent(defaultMessage)
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`

  return (
    <div className="fixed bottom-14 sm:bottom-16 md:bottom-20 right-5 sm:right-7 z-50">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="flex items-center justify-center w-13 h-13 sm:w-14 sm:h-14 bg-[#25D366] hover:bg-[#20ba59] text-white rounded-full shadow-[0_4px_20px_rgba(37,211,102,0.45)] hover:shadow-[0_6px_25px_rgba(37,211,102,0.6)] transition-all duration-300 hover:scale-110 active:scale-95 cursor-pointer focus:outline-none"
      >
        <svg 
          className="w-8 h-8 fill-current text-white" 
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.04 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.04 3.67M9.53 7.35C9.36 7.35 9.17 7.36 9 7.36C8.77 7.36 8.5 7.45 8.27 7.7C8.04 7.95 7.42 8.54 7.42 9.74C7.42 10.94 8.29 12.1 8.41 12.26C8.53 12.42 10.13 14.88 12.58 15.94C14.62 16.82 15.03 16.64 15.48 16.6C15.93 16.56 16.93 16 17.14 15.42C17.35 14.84 17.35 14.34 17.29 14.24C17.23 14.14 17.07 14.08 16.82 13.96C16.57 13.84 15.35 13.24 15.12 13.16C14.89 13.08 14.73 13.04 14.56 13.28C14.4 13.53 13.92 14.08 13.78 14.24C13.63 14.4 13.49 14.42 13.24 14.3C12.99 14.18 12.2 13.92 11.26 13.08C10.53 12.43 10.04 11.62 9.9 11.37C9.75 11.12 9.88 10.99 10.01 10.87C10.12 10.76 10.26 10.58 10.38 10.43C10.5 10.28 10.55 10.18 10.63 10.01C10.71 9.85 10.67 9.7 10.61 9.58C10.55 9.46 10.06 8.26 9.85 7.77C9.65 7.29 9.45 7.36 9.3 7.35H9.53Z" />
        </svg>
      </a>
    </div>
  )
}

export default FloatingWhatsApp
